import { Injectable } from '@angular/core';

import { DataEntry } from '@osos/shared/api';
import { FactoryBase } from '../../bases/factory/factory-base';
import { ParserFactory } from '../../services';

import { DataEntryPresenterModel } from '@osos/shared/types';
import { DataEntryParserV1Service } from '../../parsers/data-entry-pareser/data-entry-parser-v1.service';

@Injectable()
export class DataEntryFactoryService extends FactoryBase<
  DataEntry,
  DataEntryPresenterModel
> {
  constructor(
    parserFactory: ParserFactory,
    parser_v1: DataEntryParserV1Service,
  ) {
    super(parserFactory);
    // register the related parsers within the parser factory:
    parserFactory.register(parser_v1);
  }

  createDataModel(presenter: DataEntryPresenterModel): DataEntry {
    const parser = this.getParser(
      DataEntry,
      DataEntryPresenterModel,
      presenter.specificationVersion,
    );
    const result = parser.getDataModel(presenter);

    return result;
  }

  createPresenterModel(model: DataEntry): DataEntryPresenterModel {
    const parser = this.getParser(
      DataEntry,
      DataEntryPresenterModel,
      model.specificationVersion,
    );
    const result = parser.getPresenterModel(model);
    return result;
  }
}
